export enum ParentAndChildDataCheckStatusEnum {
  Unknown = 0,
  Success = 1,
  OibFailed = 2,
  DataMismatch = 4,
  NoCustody = 5,
  PersonInformationDoesNotExist = 6,
}
